import axios, { type AxiosRequestConfig, type InternalAxiosRequestConfig, type Method } from 'axios'
import Cookie from 'js-cookie'
import { EJavaBusinessResponseCode, EPHPBusinessResponseCode } from '~/enums/request'

interface CustomError {
  errorCode: number
  errorMessage: string
  errorCodeStr: string | null
}

export function isCustomError(error: any): error is CustomError {
  return error?.errorCode !== undefined && error?.errorCodeStr !== undefined && error?.errorMessage !== undefined
}

const { CancelToken } = axios
const source = CancelToken.source()

// import type { IrequestHeader } from '@/types/global';
const httpAxios = axios.create({
  timeout: 10000
})

// let showError = false

// 请求超时的等待时间,覆写库的超时默认值
// 在超时前，所有请求都会等待 6 秒
axios.defaults.timeout = 6000

// 全局请求拦截器
httpAxios.interceptors.request.use(async (config): Promise<InternalAxiosRequestConfig> => {
  const headers = useRequestHeaders()
  const runtimeConfig = useRuntimeConfig()

  const { javaHost } = runtimeConfig.public
  const phpHost = javaHost + '/open'

  const { get: getCustomHeaders } = useCustomHeaders()
  const deviceId = await generateDeviceIdByFingerprint()
  const customHeader = getCustomHeaders({ url: config.url, method: config.method, deviceId })

  let BASE_URL: any = ''

  BASE_URL = config?.open ? phpHost : javaHost
  // console.log('BASE_URL====', BASE_URL)
  // if (process.server) {
  //   BASE_URL = config?.open ? phpHost : javaHost
  // } else {
  //   BASE_URL = `${config?.open ? phpHost : javaHost}`
  // }
  if (config?.customBase && runtimeConfig.public[config?.customBase]) {
    BASE_URL = runtimeConfig.public[config?.customBase]
  }

  if (config.method === 'POST' && config?.open) {
    config.params = config?.query
  }

  if (process.client) {
    if (config?.url && !config.url.startsWith('http://') && !config.url.startsWith('https://')) {
      config.url = BASE_URL.includes('http') ? `${BASE_URL}${config.url}` : `${window.location.origin}${BASE_URL}${config.url}`
    }
  }

  console.log('headers==', headers.userAgent)

  if (config?.urlencoded) {
    customHeader['content-type'] = 'multipart/form-data'
  }

  config.headers = {
    ...config.headers,
    ...customHeader
  }
  config.baseURL = BASE_URL
  config.cancelToken = source.token

  return config
})

// 全局响应拦截器
httpAxios.interceptors.response.use(
  response => {
    const data = response?.data || response

    if ((data?.errorCode && data?.errorCode !== 0) || (data?.status && data?.status !== 200)) {
      // TODO toast 错误提示 ====》(根据传值判断是否需要展示)
      // console.error('错误提示', data)

      // 聚合错误信息
      const errorMessage = data?.message || data?.errorMsg || ''
      const errorCode = data?.status || data?.errorCode || ''

      if (response?.config?.hideToast) {
        // 不提示
      } else if (data?.errorCode !== 101 && data?.errorCode !== 30027 && data?.errorCode !== 'REPEAT_REQUEST') {
        // 针对未登录 及 请求重复 errorCode 不显示toast提示
        if (data.errCode === 555) {
          return Promise.resolve(data?.data)
        } else {
          showToast(errorMessage)
        }
      }

      switch (errorCode) {
        case EJavaBusinessResponseCode.NOT_LOGIN:
        case EPHPBusinessResponseCode.NOT_LOGIN:
          console.log('request：未登录')
          if (isInApp) {
            console.log('前往登录页面')
            native?.loginBackPage(location?.href)
          } else {
            if (location.pathname === '/login') {
              // 避免重复的login跳转, 如多个接口都报101
              return
            }
            Cookie.remove('H5_C5_AccessToken')
            navigateTo(`/login?returnUrl=${encodeURIComponent(location?.href)}`, { replace: true })
          }
          break
        case EJavaBusinessResponseCode.NOT_FOUND:
        case EJavaBusinessResponseCode.NOT_FOUND_4004:
          console.log('404')
          break
        case EJavaBusinessResponseCode.SERVER_ERROR:
        case EJavaBusinessResponseCode.SERVER_ERROR_999:
          console.log('服务器异常')
          break
        case EJavaBusinessResponseCode.MACHINE_VERIFICATION:
          console.log('需要人机校验')
          break
        case EJavaBusinessResponseCode.NOT_AUTHENTICATION:
          console.log('未认证')
          break
        case EJavaBusinessResponseCode.NOT_FULL_EIGHTEEN:
          console.log('未满十八岁')
          break
        default:
          console.log(data?.errorMsg || '')
      }

      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        ...data,
        errorMessage,
        errorCode
      })
    } else {
      // console.log('执行成功了', data)
      return Promise.resolve(data?.data)
    }

    // return response?.data
  },
  error => {
    return Promise.reject(error)
  }
)

interface Request extends AxiosRequestConfig {
  open?: boolean
  hideToast?: boolean
  customBase?: string
}

export function request({
  url,
  method,
  data,
  params,
  signal,
  open, // open ? 使用PHP接口 : 使用java接口
  hideToast, // 隐藏错误提示
  headers,
  customBase, // 使用自定义BASE URL, 一般仅在特定测试环境中使用
  ...rest
}: Request): any {
  if (!method) {
    throw new Error('method is required')
  }
  if (!url) {
    throw new Error('url is required')
  }

  method = method.toLocaleUpperCase() as Method
  data = data || {}
  params = params || {}

  return httpAxios<any>(url, {
    signal,
    method,
    data,
    params,
    open,
    hideToast,
    headers,
    customBase,
    ...rest
  })
}
